
import { defineComponent, PropType, ref } from 'vue'
import { Organization } from '@/modules/organizations'
import OrganizationsEditableFieldCompanyName from '@/components/organizations/editable-fields/company-name.vue'
import OrganizationsEditableFieldContactPersonName from '@/components/organizations/editable-fields/contact-person-name.vue'
import OrganizationsEditableFieldContactPersonEmail from '@/components/organizations/editable-fields/contact-person-email.vue'
import OrganizationsEditableFieldLogoUrl from '@/components/organizations/editable-fields/logo-url.vue'
import OrganizationsEditableFieldBusinessId from '@/components/organizations/editable-fields/business-id.vue'
import OrganizationsEditableFieldIndustry from '@/components/organizations/editable-fields/industry.vue'
import OrganizationsEditableFieldReportingDimensionsFromSso
    from '@/components/organizations/editable-fields/reporting-dimensions-from-sso.vue'
import { OrganizationsRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
    name: 'organizations-show-edit-organization',
    components: {
        OrganizationsEditableFieldReportingDimensionsFromSso,
        OrganizationsEditableFieldIndustry,
        OrganizationsEditableFieldBusinessId,
        OrganizationsEditableFieldCompanyName,
        OrganizationsEditableFieldContactPersonName,
        OrganizationsEditableFieldContactPersonEmail,
        OrganizationsEditableFieldLogoUrl
    },
    props: {
        organization: {
            type: Object as PropType<Organization>
        }
    },
    setup (props) {
        const route = useRoute()
        const router = useRouter()
        const organizationModel = ref(props.organization)

        function onGoToList () {
            router.push({ name: OrganizationsRouteNames.LIST, query: { page: route.query.page }, params: { restoreFilters: 1 } })
        }

        function onShowMembers () {
            router.push({ name: OrganizationsRouteNames.MEMBERS, query: { page: route.query.page }, params: { organizationId: route.params.organizationId } })
        }

        return {
            organizationModel,
            onGoToList,
            onShowMembers
        }
    }
})
